import { Box } from "@mui/material";
import { Ico_Deleted } from "@sagecentral/core-ui";

const DeletedNoteContent = () => (
    <Box sx={{
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        opacity: '50%'
    }}>
        <Ico_Deleted htmlColor='#888'/>
        <i>This note has been deleted by the user</i>
    </Box>
);

export default DeletedNoteContent;